import { Component, inject, OnDestroy, AfterViewInit, signal } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, RouterOutlet } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HeaderComponent } from "./ui/header-component/header-component";
import { FooterComponent } from "./ui/footer-component/footer-component";
import { MobileCartBar } from './ui/mobile-cart-bar/mobile-cart-bar';
import { ErrorNotificationComponent } from "./ui/error-notification/error-notification.component";
import { LoadingSpinnerComponent } from "./ui/loading-spinner/loading-spinner.component";

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    FontAwesomeModule,
    MobileCartBar
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private router = inject(Router);
  navigating = signal(false);
  // keep false during initial client bootstrap so client DOM matches server DOM
  // then enable after view init to render client-only elements (like mobile bar)
  isBrowser = signal(false);
  private sub: any;

  constructor() {
    this.sub = this.router.events.subscribe(evt => {
      if (evt instanceof NavigationStart) {
        this.navigating.set(true);
        if (typeof document !== 'undefined' && document?.body) {
          document.body.classList.add('navigating');
        }
      }

      if (evt instanceof NavigationEnd || evt instanceof NavigationCancel || evt instanceof NavigationError) {
        // small delay to make the transition visible and avoid flash
        setTimeout(() => {
          this.navigating.set(false);
          if (typeof document !== 'undefined' && document?.body) {
            document.body.classList.remove('navigating');
          }
        }, 60);
      }
    });
  }

  ngAfterViewInit(): void {
    if (typeof document !== 'undefined') {
      // schedule after a tick so hydration finishes first
      setTimeout(() => this.isBrowser.set(true), 0);
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe?.();
  }
}
